// extracted by mini-css-extract-plugin
module.exports = {"pagCanvas":"PagPlayer_pagCanvas__Kb1jU"};